import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faMapMarkerAlt,
  faShoppingBasket,
} from '@fortawesome/free-solid-svg-icons'

import { useCompany } from '@monorepo/hooks/App/useCompany'
import { useUser } from '@monorepo/hooks/User'
// import { PhoneLink } from 'App/Components'
import { UserActionsButton } from './UserActionsButton'
import { ContractsSwitcher } from './ContractsSwitcher'
import './style.scss'
import { Link } from 'App/Components'

type PropsType = {
  //
}

export const TopSection: React.FC<PropsType> = () => {
  const { company } = useCompany()
  const { user } = useUser()
  const addressString = [
    company.address?.city,
    company.address?.street,
    company.address?.line1,
    company.address?.line2,
    company.address?.line3,
  ]
    .filter(Boolean)
    .join(', ')

  return (
    <div className="vc_row wpb_row vc_row-fluid vc_custom_1553775458473 vc_row-has-fill hide-sticky vc-row-620359">
      <div className="container et-clearfix">
        <div className="wpb_column vc_column_container vc_col-sm-12 text-align-none">
          <div className="vc_column-inner ">
            <div className="wpb_wrapper">
              {/* <div
                id="header-icon-69631"
                className="header-icon hbe hbe-icon-element hide-default-false hide-sticky-false hbe-left size-small"
              >
                <FontAwesomeIcon icon={faParking} className="hicon" size="lg" />
              </div> */}
              {/* <div
                id="header-slogan-53642"
                className="hbe header-slogan hide-default-false hide-sticky-false hbe-left ml-2"
              >
                <span style={{ fontSize: 14, fontWeight: 500 }}>
                  Официальный дилер <span className="text-patron">Patron</span>
                </span>
              </div> */}
              <div
                id="header-icon-969829"
                className="header-icon hbe hbe-icon-element hide-default-false hide-sticky-false hbe-left size-small"
              >
                <FontAwesomeIcon
                  icon={faShoppingBasket}
                  className="hicon"
                  size="lg"
                />
              </div>
              <div
                id="header-slogan-18402"
                className="hbe header-slogan hide-default-false hide-sticky-false hbe-left ml-2"
              >
                <Link to="/about-us" className="text-nowrap text-light">
                  <small>Интернет-магазин автозапчастей</small>
                </Link>
              </div>
              <div
                id="header-icon-487577"
                className="header-icon hbe hbe-icon-element hide-default-false hide-sticky-false hbe-left size-small"
              >
                {/* <span className="hbe-toggle hicon far fa-clock" /> */}
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="hicon"
                  size="lg"
                />
              </div>
              <div
                id="header-slogan-291137"
                className="hbe header-slogan hide-default-false hide-sticky-false hbe-left ml-2"
              >
                <Link to="/contacts" className="text-nowrap text-light">
                  <small>{addressString}</small>
                </Link>
              </div>
              <UserActionsButton />
              {!user.isGuest && (
                <>
                  <div className="header-vertical-separator hbe hide-default-false hide-sticky-false hbe-right solid vertical header-vertical-separator-561232">
                    <div className="line" />
                  </div>
                  <ContractsSwitcher />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
